<template>
  <div
    v-if="pager.total !== 0"
    class="gwnl-pager"
  >
    <yxt-pagination
      :disabled="isDisabled"
      :current-page.sync="currentPage"
      :page-sizes="pageSizes || [5, 10, 20, 30, 50, 100]"
      :page-size="pager.pageSize"
      :layout="layout || 'total, prev, pager, next, sizes, jumper'"
      v-bind="pageOption"
      :total="pager.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  props: ['pager', 'total', 'pages', 'pageSize', 'offset', 'pageOption', 'layout', 'pageSizes'],
  data() {
    return {
      defaultPageSize: 20,
      currentPage: 1,
      isDisabled: false
    };
  },
  watch: {
    pager: {
      handler: function(val) {
        if (val.offset === 0) {
          this.currentPage = 1;
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.pager.total === 0) {
      this.currentPage = 0;
    }
  },
  methods: {
    // 分页pageSize变化时
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pager.pageSize = val;
      this.pager.offset = 0;
      this.$emit('handleSizeChange', val);
      this.$emit('searchData');
    },
    // 分页当前页变化时
    handleCurrentChange(val) {
      this.currentPage = val;
      this.pager.offset = (this.currentPage - 1) * this.pager.pageSize;
      this.$emit('searchData');
    },
    // 设置currentPage
    setCurrentPage(val) {
      let currentPage = +val || 1;
      if (currentPage < 0) {
        currentPage = 1;
      } else if (currentPage > this.pager.pages) {
        currentPage = this.pager.pages;
      }
      this.currentPage = currentPage;
    },
    // 设置disabled
    setDisabled(val) {
      this.isDisabled = val;
    }
  }
};
</script>

<style scoped>
  .gwnl-pager {
    float: right;
    margin-top: 16px;
  }
</style>
